export const lightSkyBlue = "#0288D1"
export const white = "#FFFFFF"
export const grey = "rgba(0, 0, 0, 0.54)"
export const red = "#D50000"
export const defaultButtonColor = "rgb(0 0 0 / 87%)"
export const articleTechnologyBackground = "#EDEDED"
export const listBackground = "#EDEDED"
export const terminalColorBlue = "#455760"
export const iconColor = "#757575"
export const archivedTextColor = "#BDBDBD"

export const lightgrey = "#F1F1F1"
export const pureblack = "#000000"
export const lightred = "#E83850"
export const lightgreen = "#37C5AB"
export const lightblue = "#00A5E5"
export const dimmedblue = "#306B8B"
export const greyblue = "#9AB7C7"
export const darkgreyblue = "#467B98"
export const verylightgrey = "#F7F7F7"
export const orangeSimulation = "#FF7A07"
export const orangeSimulationDarker = "#ED6E00"
export const backgroundDrawerColor = "#2E3336"
export const greyIcon = "#757575"

enum PlaneusColors {
  LIGHT_SKY_BLUE = "#0288D1",
  WHITE = "#FFF",
  GREY = "rgba(0, 0, 0, 0.54)",
  DEFAULT_BUTTON_COLOR = "rgb(0 0 0 / 87%)",
  ARTICLE_TECHNOLOGY_BACKGROUND = "#EDEDED",
  TERMINAL_COLOR_BLUE = "#455760",
  LIGHT_GREY = "#F1F1F1",
  PURE_BLACK = "#000000",
  LIGHT_RED = "#E83850",
  RED = "#D50000",
  LIGHT_GREEN = "#37C5AB",
  LIGHT_BLUE = "#00A5E5",
  HIGHLIGHT_BLUE = "#E0F1FA",
  ORANGE = "#FF8C00",
  DIMMED_BLUE = "#306B8B",
  GREY_BLUE = "#9AB7C7",
  DARK_GREY_BLUE = "#467B98",
  VERY_LIGHT_GREY = "#F7F7F7",
  WARNING = "#F09300",
  ORANGE_SIMULATION = "#FF7A07",
  ORANGE_SIMULATION_DARKER = "#ED6E00",
  BACKGROUND_DRAWER_COLOR = "#2E3336",
}

enum DashboardColors {
  RED = "#E53935",
  ORANGE = "#FFA000",
  GREEN = "#37C5AB",
  GREY = "#BDBDBD",
  LIGHT_GREY = "#D3D3D3",
  DEFAULT = "#E5E5E5",
}

export { PlaneusColors, DashboardColors }
